import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { CustomRadioButton } from '../../../../components'

import './change-product-modal.css'

import { observer } from "mobx-react"
import PropTypes from 'prop-types';
import OptimizationStore from 'modules/optimization/store/OptimizationStore';
import OptimizationStoreOld from 'modules/optimization-old/store/OptimizationStore';
import changeProduct from 'modules/optimization/utils/change-product/changeProduct'

const ChangeProductModal = observer(

  class ChangeProductModal extends Component {
    constructor(props) {
      super(props)

      this.state = {
        selectedProduct: {},
        store: OptimizationStoreOld,
        filterProducts: [],
        allProductLists: OptimizationStore.allProductListData

      }
    }

    componentDidMount() {
      let currentLocation = window.location.pathname
      if (!currentLocation.includes("customization-old")) {
        this.setState({ store: OptimizationStore })
        this.setState({ filterProducts: this.state.allProductLists })
      }

    }


    onChangeProduct(value) {
      this.setState({ selectedProduct: value })
    }

    filterProducts(event) {
      let val = event.target.value
      let filterProduct = this.state.allProductLists.filter((item) => item.plan_name.toLowerCase().includes(val.toLowerCase()))
      if (filterProduct.length > 0) {
        this.setState({ filterProducts: filterProduct })
      }
    }

    onSubmitProduct() {

      let currentLocation = window.location.pathname
      if (!currentLocation.includes("customization-old")) {
        changeProduct(this.state.selectedProduct, this.props.data, this.props.cardKey)
      } else {
        this.state.store.onChangeProduct(this.state.selectedProduct, this.props.data, this.props.cardKey)
      }
      this.setState({ selectedProduct: {} })
    }

    onriskLabel(risk) {
      let riskSubTitle = {
        low: "Fully guaranteed returns",
        medium: "Partially guaranteed returns",
        high: "No guaranteed returns"
      }
      return riskSubTitle[risk];
    }

    onriskStyle(risk) {
      let riskSubTitle = {
        low: "text-success",
        medium: "text-secondary",
        high: "text-danger"
      }
      return riskSubTitle[risk];

    }






    // componentDidUpdate(prevProps, prevState) {
    //   if(prevState.selectedProduct.plan_name &&  this.state.selectedProduct.plan_name && prevState.selectedProduct.plan_name === this.state.selectedProduct.plan_name) {
    //     this.setState({ selectedProduct: {} })
    //   }
    // }
    render() {
      let { show, onHide } = this.props;
      console.log("allProductLists", this.state.allProductLists)
      return (
        this.state.allProductLists && <div>
          <Modal
            className='change-product-list-modal left-bottom-swipe-modal'
            show={show}
            onHide={() => this.state.store.isChangeProductModalOpen = false}
            keyboard={false}
          >
            <Modal.Header closeButton className='border-0 shadow-sm'>
              <Modal.Title className='font-weight-medium font-size-20 font-size-md-28 primary-title-label-color w-100 text-center align-self-center pl-5'>
                Select Product
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className=''>
              <div>
                <input type='text'
                  className='w-100 my-2 rounded border search-bar-select-product '
                  placeholder='Search Product'
                  onChange={(value) => { this.filterProducts(value) }}
                ></input>
              </div>
              {this.state.filterProducts.map((value, index) => (
                <div className='p-3 modal-product-list-card' key={index}>
                  <CustomRadioButton
                    id={value.id}
                    shape='rounded'
                    title={value.plan_name}
                    riskSubTitle={this.onriskLabel(value?.risk)}
                    riskSubTitleStyle={this.onriskStyle(value?.risk)}
                    groupName='productlist'
                    containerStyle='my-0 w-100'
                    titleStyle='text-primary-title-label-color font-weight-normal text-wrap font-size-18 font-size-md-18 pl-2'
                    checkmarkPosition='mt-1'
                    isChecked={this.state.selectedProduct.id === value.id}
                    mark='checkmark'
                    onChange={() => this.onChangeProduct(value)}
                  />
                </div>
              ))}

            </Modal.Body>
            <Modal.Footer className='change-product-reason-modal-footer-btn-group'>
              <Button variant='secondary' className='font-size-18 ml-1' disabled={Object.keys(this.state.selectedProduct).length === 0} onClick={() => this.onSubmitProduct()}>
                Change Product
              </Button>
              <Button variant='outline-secondary' className='font-size-18 mr-1' onClick={() => this.state.store.isChangeProductModalOpen = false}>
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>

        </div>
      )
    }
  }
)

ChangeProductModal.propTypes = {
  show: PropTypes.bool.isRequired,
}

export default ChangeProductModal
